import { Seo, orgJsonLd, faqJsonLd } from "../components/Seo";
import { useI18n } from "../i18n/LanguageContext";
import { Hero } from "../components/Hero";
import { DeveloperLogos } from "../components/DeveloperLogos";
import { WhyUs } from "../components/WhyUs";
import { Projects } from "../components/Projects";
import { FeaturedListone } from "../components/FeaturedListone";
import { Stats } from "../components/Stats";
import { DistressDeals } from "../components/DistressDeals";
import { Testimonials } from "../components/Testimonials";
import { FAQ } from "../components/FAQ";
import { Contact } from "../components/Contact";

export default function Home() {
  const { t, c } = useI18n();
  return (
    <>
      <Seo path="/" title={t.seo.home.title} description={t.seo.home.desc} jsonLd={[orgJsonLd, faqJsonLd(c.FAQS)]} />
      <Hero />
      <DeveloperLogos />
      <WhyUs />
      <Projects />
      <FeaturedListone />
      <Stats />
      <DistressDeals />
      <Testimonials />
      <FAQ />
      <Contact />
    </>
  );
}
